import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import type { Task } from "../types";

// Display-only badge for a task that has been pushed to Plane. Shows the
// linked work item's identifier + last-synced state, linking out to Plane.
// Rendered on every task surface (Action Items rows, task detail).
export const PlaneIssueBadge = ({
  task,
  className,
}: {
  task: Task;
  className?: string;
}) => {
  if (!task.plane_issue_id) return null;
  return (
    <a
      href={task.plane_url ?? undefined}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={task.plane_state ? `Plane: ${task.plane_state}` : "View in Plane"}
      className={cn(
        "inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded bg-muted text-muted-foreground hover:underline align-middle",
        className,
      )}
    >
      <ExternalLink className="w-3 h-3" />
      {task.plane_identifier ?? "Plane"}
      {task.plane_state ? ` · ${task.plane_state}` : null}
    </a>
  );
};
